import { lazy, Suspense } from 'react'

/**
 * When VITE_MAINTENANCE_MODE is 'true' at build time, the dynamic import below
 * is never reached. Vite/Rollup dead-code-eliminates the entire MainApp chunk
 * (including router, routeTree, and all route components) from the bundle,
 * so route paths are not discoverable by inspecting the JS output.
 */
const MainApp =
  import.meta.env.VITE_MAINTENANCE_MODE === 'true'
    ? null
    : lazy(() => import('./MainApp.tsx'))

const MaintenancePage = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif', color: '#555' }}>
    <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Under Maintenance</h1>
    <p style={{ fontSize: '1rem' }}>We'll be back.</p>
  </div>
)

export const App = () => {
  if (!MainApp) return <MaintenancePage />

  return (
    <Suspense>
      <MainApp />
    </Suspense>
  )
}
